import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { InputWrapper } from './styles';

type Props = {
  visible: boolean;
  onClose: () => void | Promise<void>;
  loading: boolean;
  name: string;
  credentialsValue: string;
  setName: (v: string) => void;
  setCredentialsValue: (v: string) => void;
  onSave: () => void | Promise<void>;
};

const CredentialsDialog: React.FC<Props> = ({
  visible, onClose, loading, name, credentialsValue, setName, setCredentialsValue, onSave,
}) => (
  <DialogComponent
    visible={visible}
    width="420px"
    isModal
    showCloseIcon
    header="Zugangsdaten (Key/Value)"
    close={onClose}
    buttons={[
      {
        buttonModel: { content: loading ? 'Speichere...' : 'Speichern', isPrimary: true, cssClass: 'e-custom modal-dialog-btn' },
        click: onSave,
      },
    ]}
  >
    <div style={{ padding: 16 }}>
      <InputWrapper>
        <TextBoxComponent value={name} floatLabelType="Auto" placeholder="Name" input={(e: any) => setName(e.value)} />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent
          value={credentialsValue}
          floatLabelType="Auto"
          placeholder="Credentials (z. B. JSON oder key=value)"
          input={(e: any) => setCredentialsValue(e.value)}
        />
      </InputWrapper>
    </div>
  </DialogComponent>
);

export default CredentialsDialog;
